import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DocumentClassification,
  DocumentResourceV4,
} from '@models/resources/document.model';

/**
 * Facade für die Kundendokumente (Customer-Side, V4).
 *
 * Sprint 5c S5c-12 — Refactor von V3 auf V4:
 * - Liste liefert `DocumentResourceV4[]` (BE-Wire-Shape mit `title`,
 *   `filename`, `mime_type`, `file_size`, `download_url`, `created_at`,
 *   `type` statt `classification`).
 * - Server filtert auf `visible_to_customer=true` + eigener `customer_id`,
 *   das FE-Modell hat diese beiden Felder nicht mehr.
 *
 * Zwei konkrete Implementierungen (Switch via `environment.dataSource`):
 * - `DummyDocumentsFacade` — liest `DEMO_DOCUMENTS_V4`, Download liefert
 *   ein lokales Placeholder-PDF.
 * - `HttpDocumentsFacade` — `GET /api/me/documents` + `GET /api/documents/{id}/download`.
 *
 * Admin-Code hat eine eigene Facade (`ADMIN_DOCUMENTS_FACADE`) und nutzt
 * weiterhin die V3-`DocumentResource`-Shape bis zum Sprint-6-Refactor.
 */
export interface DocumentsFilter {
  search?: string;
  classification?: DocumentClassification | 'all';
}

export interface DocumentsFacade {
  list(filter?: DocumentsFilter): Observable<DocumentResourceV4[]>;
  download(id: number): Observable<Blob>;
}

export const DOCUMENTS_FACADE = new InjectionToken<DocumentsFacade>('DocumentsFacade');
